import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// IMPORT REMOVIDO: ngx-highlightjs

import { CoreCommonModule } from '@core/common.module';
import { CoreCardSnippetComponent } from '@core/components/card-snippet/card-snippet.component';

@NgModule({
  declarations: [CoreCardSnippetComponent],
  // REMOVIDO O HighlightModule DOS IMPORTS
  imports: [CommonModule, NgbModule, CoreCommonModule], 
  // PROVIDERS LIMPOS
  providers: [], 
  exports: [CoreCardSnippetComponent]
})
export class CardSnippetModule {}